import { SVGComponentProps } from "./utils/Types"

const UserIcon = ({ width = 29, height = 29, className }: SVGComponentProps) => {
    return (
        <svg className={`text-current ${className}`} width={width} height={height} viewBox="0 0 24 24" fill="none">
            <path d="M16 15H8C5.79086 15 4 16.7909 4 19V21H20V19C20 16.7909 18.2091 15 16 15Z" className="stroke-current" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" className="stroke-current" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default UserIcon
